import { Pipe, PipeTransform } from '@angular/core';
import { InstallationinspectionInfoPluginService } from './installation-inspection-info.service';

@Pipe({
    name: 'subType',
    standalone: false
})
export class SubTypePipe implements PipeTransform {
  constructor(private service: InstallationinspectionInfoPluginService) {}

  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.service.getSubTypes());
  }
}
